// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__ANKwx","actionsCol":"EnrolledClinics_actionsCol__LHuit"};